import { ApiService } from '@/axios'


export const getFabricantes = () => {
    return ApiService.get('fabricantes')
}